import { render, staticRenderFns } from "./RecordsOfTest.vue?vue&type=template&id=b852196c&scoped=true&"
import script from "./RecordsOfTest.vue?vue&type=script&lang=js&"
export * from "./RecordsOfTest.vue?vue&type=script&lang=js&"
import style0 from "./RecordsOfTest.vue?vue&type=style&index=0&id=b852196c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b852196c",
  null
  
)

export default component.exports